import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import styled from 'styled-components';

import Badge from '../../shared/Badge';
import { ADDITIONAL_PERIODS_LIMITATION } from '../../../constants/event';
import { FULL_DATE_FORMAT } from '../../../constants/date';
import EventDropdownButton from '../EventDropdownButton';
import Period, { getGlobalDates } from './Period';

const getDifference = ({ fromGlobal, toGlobal }) => toGlobal.diff(fromGlobal, 'days');

const getFullPeriodValues = (difference, fromGlobal) => {
  const from = fromGlobal.startOf('day').subtract(difference, 'days').format(FULL_DATE_FORMAT);
  return [from, moment(from).add(difference, 'days').format(FULL_DATE_FORMAT)];
};

const getToPeriodValue = (periodFrom, difference) => {
  return moment(periodFrom).add(difference, 'days').format(FULL_DATE_FORMAT);
};

const StyledEventPeriodsContainer = styled.div`
  width: 100%;
  margin-top: 10px;

  .button-content {
    display: flex;
    justify-content: center;
  }

  .right-indent {
    margin-right: 10px;
  }
`;

const EventPeriods = ({
  onCopyPeriod,
  uniqueChar,
  addPeriod,
  setPeriod,
  deletePeriod,
  periods,
  isShow,
  setShow,
  globalFilter,
  zoneId,
  onChangeSplitColumn,
}) => {
  const [badgeCount, setBadgeCount] = useState(0);

  // при изменении globalFilter и открытом окне редактирования периода определяются дефолтные значения.
  useEffect(
    () =>
      periods.forEach((period, index) => {
        let from = '';
        let to = '';

        if (isShow) {
          const { fromGlobal, toGlobal } = getGlobalDates(globalFilter, zoneId);
          const difference = getDifference({ fromGlobal, toGlobal });
          [from, to] =
            period.from.length !== 0
              ? // если изменение глобального фильтр не касается дополнительного
                // то изменяем только значение to в дополнительном.
                [period.from, getToPeriodValue(period.from, difference)]
              : // в ином случае изменяем значения from и to.
                getFullPeriodValues(difference, fromGlobal);
          onChangeSplitColumn();
          setPeriod(index, from, to);
        }
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [globalFilter, isShow, periods.length]
  );

  useEffect(() => {
    // если остается пустой период - выходим из Show мода
    const firstPeriodIsEmpty = periods[0].from === '' && periods[0].to === '';

    if (firstPeriodIsEmpty) {
      setShow(false);
      // если остается пустой период устанавливаем кол-во доп периодов - 0
      setBadgeCount(0);
    } else {
      setBadgeCount(periods.length);
    }
  }, [setShow, periods]);

  const isLimitExcess = periods.length >= ADDITIONAL_PERIODS_LIMITATION;

  const periodElements = periods.map((period, index) => {
    const isLast = index === periods.length - 1;
    const uniqueCharString = `${uniqueChar}${index + 1}.`;

    const deletePeriodHandler =
      periods.length !== 1 ? () => deletePeriod(index) : () => setPeriod(index, '', '');
    const setPeriodHendler = (from, to) => setPeriod(index, from, to);

    return (
      <Period
        key={uniqueCharString}
        globalFilter={globalFilter}
        zoneId={zoneId}
        period={period}
        isLast={isLast}
        uniqueChar={uniqueCharString}
        addPeriod={addPeriod}
        deletePeriod={deletePeriodHandler}
        setPeriod={setPeriodHendler}
        isLimitExcess={isLimitExcess}
      />
    );
  });

  return (
    <StyledEventPeriodsContainer
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => {
        setShow(true);
        onCopyPeriod(JSON.parse(e.dataTransfer.getData('periods')));
      }}
    >
      <EventDropdownButton
        onClick={() => {
          setShow(!isShow);
        }}
      >
        <div
          className="button-content"
          onDragStart={(e) => e.dataTransfer.setData('periods', JSON.stringify(periods))}
          draggable
        >
          {badgeCount > 0 && <Badge style={{ marginRight: 5 }} count={badgeCount} />}
          <div>Compare with period</div>
        </div>
      </EventDropdownButton>

      {isShow && <div className="right-indent">{periodElements}</div>}
    </StyledEventPeriodsContainer>
  );
};

export default EventPeriods;
